import { DialogContent, DialogContentProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '../arranger';
import { spc } from '../spacer';

interface Props extends DialogContentProps {
  className?: string;
}

const WizardDialogContentImpl: React.FC<Props> = ({ className, children }) => {
  return (
    <DialogContent className={className}>
      <Arranger className="dialog-content" direction="column">
        {children}
      </Arranger>
    </DialogContent>
  );
};

/**
 * A convenience wrapper around `<DialogContent/>` that centers the content area
 * and sets a max-width.
 *
 * This is meant to be used with `<WizardDialog/>`
 */
export const WizardDialogContent = muiStyled(WizardDialogContentImpl)(
  ({ theme }) => css`
    display: flex;
    justify-content: center;

    .dialog-content {
      flex: 1;
      max-width: 716px;
      padding-top: ${theme.spacing(spc.container_padding_l)};
    }
    /* extra large buttons */
    & .MuiButton-root {
      width: 100%;
      flex-grow: 1;
      padding: 14px 22px;
      font-size: 16px;
    }
  `
);
